import { Grid, Paper } from '@mui/material';
import { Outlet, useParams } from 'react-router-dom';

import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useState, useEffect } from 'react';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { District } from 'src/shared/models/user';
import { getDistrictById } from 'src/shared/services/districtService';
import { useTranslation } from 'react-i18next';
import DistrictPageTabNavigation from '../components/districtPageTabNavigation';

export const DistrictPage = () => {
  const params = useParams();
  const { t } = useTranslation(['common']);
  const [, setLoading] = useState<boolean>(false);

  const isMounted = useIsMounted();

  const [district, setDistrict] = useState<District>();

  const districtPageTabs: SelectableItem[] = [
    {
      label: t('common:organization.pageTabs.form'),
      value: `${RoutesEnum.OrganizationDistricts}/${params.id}`,
    },
    {
      label: t('common:organization.pageTabs.fee'),
      value: `${RoutesEnum.OrganizationDistricts}/${params.id}/avgift`,
    },
    {
      label: t('common:organization.pageTabs.board'),
      value: `${RoutesEnum.OrganizationDistricts}/${params.id}/styrelse`,
    },
    {
      label: t('common:organization.pageTabs.elected'),
      value: `${RoutesEnum.OrganizationDistricts}/${params.id}/fortroendevalda`,
    },
    {
      label: t('common:organization.pageTabs.users'),
      value: `${RoutesEnum.OrganizationDistricts}/${params.id}/users`,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await getDistrictById(params.id);
        if (isMounted()) {
          setDistrict(result.data);
        }
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      } finally {
        if (isMounted()) setLoading(false);
      }
    };
    if (params.id) {
      fetchData();
    }
  }, [isMounted, params.id]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <MainContentHeader title={district?.countyAss ?? ''} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <DistrictPageTabNavigation tabs={districtPageTabs} />
          <Outlet />
        </Paper>
      </Grid>
    </Grid>
  );
};
